import { Fragment } from "react";
import {
  Chart,
  ArgumentAxis,
  ValueAxis,
  BarSeries,
  Legend,
} from "@devexpress/dx-react-chart-material-ui";

import { addThousandSeparator } from "../../shared/util/addThousandSeparator";
import Roots from "../../shared/components/MUIThemed/GraphLegendsRoot";
import Label from "../../shared/components/MUIThemed/GraphLegendsLabel";
import {
  setSimCashFlowData,
  setSimCashFlowMobileData,
} from "../../shared/data/dynamic";
import { openWhatsapp } from "../../shared/util/openWhatsapp";
import { SimulationResultsData, WebsiteData } from "../../shared/data/types";

interface SimulationResultsProps {
  loadedResults: SimulationResultsData;
  isMobile: boolean;
  loadedWebsite: WebsiteData;
}

export const SimulationResults = (props: SimulationResultsProps) => {
  const { loadedResults, isMobile, loadedWebsite } = props;
  const cashFlow = setSimCashFlowData(loadedResults);
  const cashFlowMobile = setSimCashFlowMobileData(loadedResults);

  return (
    <Fragment>
      <div className="proposal-center-flex">
        <p
          className="proposal-equipament-item-title proposal-avoid-break-after"
          style={{
            color: loadedWebsite.themeColor,
            marginTop: !isMobile ? "1.5rem" : "1rem",
          }}
        >
          Resultados da Simulação
        </p>
      </div>
      <div className="proposal-center-flex" style={{ marginTop: "1rem" }}>
        <div className="proposal-finantial-viability-grid">
          <p className="proposal-data-text-label">Faixa de valor do sistema:</p>
          <p
            style={{
              color: loadedWebsite.themeColor,
              fontWeight: 700,
            }}
            className="proposal-data-text-info"
          >
            {`R$ ${addThousandSeparator(
              loadedResults?.finalPrice * 0.7
            )} - R$ ${addThousandSeparator(loadedResults?.finalPrice * 1.2)}`}
          </p>
          <p className="proposal-data-text-label proposal-info-spacing">
            Reajuste anual de energia:
          </p>
          <p className="proposal-data-text-info">
            {loadedResults?.inflation ? `${loadedResults?.inflation}%` : "10%"}
          </p>
          <p className="proposal-data-text-label proposal-info-spacing">
            Payback (tempo de retorno do investimento):
          </p>
          <p className="proposal-data-text-info">
            {`${loadedResults?.paybackYears} anos e ${
              loadedResults?.paybackMonths
            } ${loadedResults?.paybackMonths === 1 ? "mês" : "meses"}`}
          </p>
          <p className="proposal-data-text-label proposal-info-spacing">
            ROI (retorno sobre investimento):
          </p>
          <p className="proposal-data-text-info">
            {`${addThousandSeparator(loadedResults?.roi)} vezes`}
          </p>
          <p className="proposal-data-text-label proposal-info-spacing">
            Economia total em 25 anos:
          </p>
          <p
            style={{
              color: loadedWebsite.themeColor,
              fontWeight: 700,
            }}
            className="proposal-data-text-info"
          >
            {`R$ ${addThousandSeparator(loadedResults?.totalEconomy)}`}
          </p>
        </div>
      </div>
      <p
        className="proposal-equipament-item-title proposal-avoid-break-after"
        style={{
          color: loadedWebsite.themeColor,
          marginTop: "3rem",
          marginBottom: "1rem",
        }}
      >
        Fluxo de Caixa (Ano x R$)
      </p>
      <div className={"proposal-graph-pdf"}>
        <Chart height={400} data={isMobile ? cashFlowMobile : cashFlow}>
          <ArgumentAxis />
          <ValueAxis />
          <BarSeries
            name="Fluxo de Caixa (R$)"
            color={loadedWebsite.themeColor}
            valueField="flow"
            argumentField="year"
          />
          <Legend
            position="bottom"
            rootComponent={isMobile ? Roots.RootMobile : Roots.Root}
            labelComponent={Label}
          />
        </Chart>
      </div>
      {!!loadedWebsite.companyData?.social?.whatsapp && (
        <div className="proposal-center-flex" style={{ marginTop: "1rem" }}>
          <button
            style={{ backgroundColor: loadedWebsite.themeColor }}
            className="btn btn--sm-animation btn--custom-color"
            onClick={() => {
              openWhatsapp(
                parseFloat(
                  loadedWebsite.companyData?.social?.whatsapp.replace(/\D/g, "")
                )
              );
            }}
          >
            CHAME-NOS NO WHATSAPP!
          </button>
        </div>
      )}
    </Fragment>
  );
};
